import { IFinalizedReport } from './reports'

export interface AdjudicateClaimResponse {
    id: string
    claimNumber: string
    report: IFinalizedReport
    results?: ClaimServiceResult[]
    edi835?: string
    type: 'adjudicate-result'
}

export interface ClaimServiceResult {
    serviceLine: string
    cptCode: string
    memberIsEligible: boolean
    chargedAmount: number
    remittanceAmount: number
    updatedAccumulators: { [memberIdAndCpt: string]: { value: number; lastAccumulated: number } }
    planId?: string
}

export const generateAdjudicationTextReport = (report: IFinalizedReport) =>
    `
Claim Adjudication Summary

Summary:
  - Status: ${report.summary.status}
  - Submitted to Rhiza Network: ${report.summary.submittedToNetwork}
  - Processing Time: ${report.summary.processingTime}
  - Total Charged: ${report.summary.totalCharged}
  - Total to Remit: ${report.summary.toRemit}
  - Patient Responsibility: ${report.summary.patientResponsibility}
  - Report ID: ${report.summary.id}
  
Preprocessing:
  - Status: ${report.report.preprocessing.status}
  - Details: \n    - ${report.report.preprocessing.details.join('\n    - ')}
  
Eligibility:
  - Status: ${report.report.eligibility.status}
  - Details: \n    - ${report.report.eligibility.details.join('\n    - ')}
  
Contract:
  - Status: ${report.report.contract.status}
  - Details: \n    - ${report.report.contract.details.join('\n    - ')}
  
Payment and Publication:
  - Status: ${report.report.paymentAndPublication.status}
  - Details: \n    - ${report.report.paymentAndPublication.details.join('\n    - ')}
`
